module.exports = __webpack_public_path__ + "9e27a3013646bf4adf1a740d463d5ea8.svg";